import {
  FD_NODE_DRAG_START,
  FD_SET_DRAG_TO_CONNECT_TARGET,
  FD_NODE_DRAG_STOP,
} from 'actions/flowDesigner/dragToConnect';

const getDefaultState = () => ({
  dragItemData: null,
  dropTarget: null,
});

export default function flowDesignerDragToConnect(
  state = getDefaultState(),
  action,
) {
  const { type, payload } = action;
  switch (type) {
    case FD_NODE_DRAG_START: {
      return {
        ...getDefaultState(),
        dragItemData: payload,
      };
    }
    case FD_NODE_DRAG_STOP: {
      return getDefaultState();
    }
    case FD_SET_DRAG_TO_CONNECT_TARGET: {
      // Payload is of structure: `{ type: 'port', blockId, id }`. Type may be 'port', or 'edge'.
      return {
        ...state,
        dropTarget: payload,
      };
    }
    default:
      return state;
  }
}
